// extracted by mini-css-extract-plugin
export default {"heading":"PageHeading_heading__RY2zg","title":"PageHeading_title__nlt3K"};